import PropTypes from "prop-types";
import { TableCell } from "@mui/material";
import { CM_TOOLTIPS } from "./utils/tooltipsContent";

export default function ResizableHeaderCell({
  columnKey,
  children,
  width,
  onResizeStart,
  resizable = true,
  className = "",
  rowSpan,
  colSpan,
}) {
  const fixedStyle = width != null
    ? { width, minWidth: width, maxWidth: width, boxSizing: "border-box" }
    : undefined;

  return (
    <TableCell
      className={`cm-resizable-th ${className}`.trim()}
      style={fixedStyle}
      rowSpan={rowSpan}
      colSpan={colSpan}
    >
      <div className="cm-resizable-th-content">{children}</div>
      {resizable && onResizeStart && (
        <button
          type="button"
          aria-label={`Ridimensiona colonna ${columnKey}`}
          title={CM_TOOLTIPS.ridimensionaColonna}
          className="cm-col-resizer"
          onMouseDown={(event) => onResizeStart(event, columnKey)}
        />
      )}
    </TableCell>
  );
}

ResizableHeaderCell.propTypes = {
  columnKey: PropTypes.string.isRequired,
  children: PropTypes.node,
  width: PropTypes.number,
  onResizeStart: PropTypes.func,
  resizable: PropTypes.bool,
  className: PropTypes.string,
  rowSpan: PropTypes.number,
  colSpan: PropTypes.number,
};
